import useSWR from 'swr';
import useAuthStore from '@/stores/profile/authStore';
import { getUser } from '@/utils/profile/getUser';
import React from 'react';

const fetcher = () => getUser();

const useVerifyUser = () => {
    const { data, error } = useSWR('verifyUser', fetcher, {
        dedupingInterval: 300000, // 5 minutes caching
        revalidateOnFocus: false, // Prevent re-fetching on window focus
    });

    const setIsLoggedIn = useAuthStore((state) => state.setIsLoggedIn);
    const setIsAuthVerified = useAuthStore((state) => state.setIsAuthVerified);
    const isAuthVerified = useAuthStore((state) => state.isAuthVerified);

    React.useEffect(() => {
        if (!isAuthVerified && (data !== undefined || error)) {
            setIsLoggedIn(!!data);
            setIsAuthVerified(true);
        }
    }, [data, error, isAuthVerified, setIsLoggedIn, setIsAuthVerified]);

    return {
        isLoading: !isAuthVerified,
        isLoggedInGlobal: !!data,
        mobile: data?.data?.user?.mobile || null,
        user: data?.data?.user || null, // ✅ Expose user data
    };
};

export default useVerifyUser;
